import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';
import { arenaService } from '@/services/arena';
import useVuelidate from '@vuelidate/core';
import { integer, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useArenaMedalAdd() {
    const router = useAppRouter();
    const { excuteAndNotify } = useCrudActions();

    const model = reactive({
        name: '',
        rank: null,
        imageFile: null
    });

    const validations = {
        name: { required },
        rank: { required, integer, min: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const create = excuteAndNotify({
        validator: v$,
        request: () => arenaService.medal.create(model.name, model.rank, model.imageFile),
        onSuccess: () => router.push({ name: ROUTE_NAME_ARENA.MEDAL.INDEX })
    });

    return { model, v$, create };
}
